export default {
  "content": "<path d=\"M12.028 5H3.972a.5.5 0 00-.407.79l4.028 5.64a.5.5 0 00.814 0l4.028-5.64a.5.5 0 00-.407-.79z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};